import {useCallback} from "react";
import {getSubmit, postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";
import {isLoadMoreItems, reverseMatcherItems, reverseMatcherGroupBy, reverseMatcherBatchGroupBy} from "../@signals";


export default function useReverseMatcherItems() {

	const handleSubmit = useCallback((id_mapping = null) => {
		isLoadMoreItems.value = true
		const params = {}
		if (id_mapping) params.id_mapping = id_mapping
		getSubmit(`${BACKEND_APIS.MATCHERS}/reverse/load-items`, params).then(({ items, batchGroupBy }) => {
			reverseMatcherItems.value = [...(reverseMatcherItems.value || []), ...items]
			if (batchGroupBy) {
				reverseMatcherBatchGroupBy.value = batchGroupBy
				reverseMatcherGroupBy.value = batchGroupBy
			}
			isLoadMoreItems.value = false
		}).catch(() => isLoadMoreItems.value = false)
	}, [])

	const handleMoreProducts = useCallback(() => {
		reverseMatcherItems.value = null
		postSubmit(`${BACKEND_APIS.MATCHERS}/skus/disabled-filters`).then(() => {
			handleSubmit()
		}).catch(() => reverseMatcherItems.value = [])
	}, [])


	return {
		handleSubmit,
		handleMoreProducts
	}
}